import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { useHandleDeleteAnalysis } from "components/workspaces/hooks/handleDeleteAnalysis";
import { setDynamicText } from "components/workspaces/store/workspaces";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsDeleteAnalysisDialogAction = () => {
    const dispatch = useDispatch();
    const messagesDialog = useSelector((state) => state.messagesDialog, isEqual);
    const { handleDeleteAnalysis } = useHandleDeleteAnalysis();
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                handleDeleteAnalysis(messagesDialog?.customProp).then(() => dispatch(setDynamicText(language.en.dashboard.deletionAnalysisMsg)));
                dispatch(closeDialog());
            } }),
        React.createElement(CloseDialogButton, null));
};
